var _rect, _path, _path2, _path3, _path4, _path5, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6473_1181)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.40039 14.6665H26.3996V21.9998H-4.40039V14.6665Z",
    fill: "#6FB1D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.40039 0H26.3996V7.33333H-4.40039V0Z",
    fill: "#DB5F7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33301 5.86657H8.79967V7.33324H7.33301V5.86657ZM10.2663 4.3999H11.733V7.33324H10.2663V4.3999ZM13.1997 5.86657H14.6663V7.33324H13.1997V5.86657Z",
    fill: "#B3D7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7331 4.3999H13.1998V7.33324H11.7331V4.3999ZM8.7998 4.3999H10.2665V7.33324H8.7998V4.3999Z",
    fill: "#6FB1D6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6473_1181",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 8,
    height: 10
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 12.4668C14.6663 14.4908 13.0237 16.1335 10.9997 16.1335C8.97567 16.1335 7.33301 14.4908 7.33301 12.4668V7.3335H14.6663V12.4668Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6473_1181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 12.4668C14.6663 14.4908 13.0237 16.1335 10.9997 16.1335C8.97567 16.1335 7.33301 14.4908 7.33301 12.4668V7.3335H14.6663V12.4668Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79967 14.6668H10.2663V16.1335H8.79967V14.6668ZM11.733 14.6668H13.1997V16.1335H11.733V14.6668ZM10.2663 13.2002H11.733V14.6668H10.2663V13.2002ZM8.79967 11.7335H10.2663V13.2002H8.79967V11.7335ZM11.733 11.7335H13.1997V13.2002H11.733V11.7335ZM10.2663 10.2668H11.733V11.7335H10.2663V10.2668ZM8.79967 8.80016H10.2663V10.2668H8.79967V8.80016ZM11.733 8.80016H13.1997V10.2668H11.733V8.80016ZM10.2663 7.3335H11.733V8.80016H10.2663V7.3335ZM13.1997 7.3335H14.6663V8.80016H13.1997V7.3335ZM13.1997 10.2668H14.6663V11.7335H13.1997V10.2668ZM13.1997 13.2002H14.6663V14.6668H13.1997V13.2002ZM7.33301 13.2002H8.79967V14.6668H7.33301V13.2002ZM7.33301 10.2668H8.79967V11.7335H7.33301V10.2668ZM7.33301 7.3335H8.79967V8.80016H7.33301V7.3335Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#D2D5D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6473_1181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.fb8b21d45908eb5f8c8da5e26a121351.svg";
export { ForwardRef as ReactComponent };